import * as actions from './actions';
import reducer from './reducer'
import * as selectors from './selectors';

export {default as LoginHome} from './loginHome/loginHome'

export default {actions, reducer, selectors};